import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.duration.xshort',
		useFor: 'Subtle pressed states, quick exits (e.g. Popup exit)',
		value: '100ms',
	},
	{
		tokenName: 'motion.duration.short',
		useFor: 'Interactive emphasis, small entrances (e.g. Popup enter)',
		value: '150ms',
	},
	{
		tokenName: 'motion.duration.medium',
		useFor: 'Medium exit transitions (e.g. Modal exit, Flag exit)',
		value: '200ms',
	},
	{
		tokenName: 'motion.duration.long',
		useFor: 'Medium entrance transitions (e.g. Modal enter, Flag enter)',
		value: '250ms',
	},
	{
		tokenName: 'motion.duration.xlong',
		useFor: 'Large transitions (e.g. page-level transitions)',
		value: '400ms',
	},
	{
		tokenName: 'motion.duration.xxlong',
		useFor: 'Large transitions (e.g. onboarding steps, full-screen overlays)',
		value: '600ms',
	},
];

/**
 * __Duration transition table__
 */
export const MotionDurationTransitionTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-duration-transition-table" />;
};
